module.exports = __webpack_public_path__ + "img/ssggyhb.26cf2033.png";